import moment from "moment";

export const getTime = (value, format) => {
  return moment(value?.toDate()).format(format);
};

export const converTime = (second) => {
  const hours = Math.floor(second / 3600);
  const minutes = Math.floor((second % 3600) / 60);
  const seconds = second % 60;

  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(seconds).padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const convertVnTime = (value) => {
  return moment(value).tz("Asia/Ho_Chi_Minh").format("YYYY-MM-DD HH:mm:ss");
};
